import {
  PropertyTranslator,
  IGenericRequestParametersTranslator,
  IOwnedEntityParametersTranslator,
  INamedEntityLabels,
  IPermissionedEntityLabels,
  IEntryRecordLabels,
  IModificationRecordLabels,
  IUniqueEntityLabels,
  IUniqueEntityParametersTranslator,
  IEntryRecordParametersTranslator,
  IModifiedRecordParametersTranslator,
} from "./GenericTranslator";
import {
  GenericEntityOrderBy,
  OwnedOrderBy,
  EntityConstants,
  ICreatedRecordParameters,
  IEntityMinimalModel,
  IEntryRecord,
  IGenericRequestParameters,
  IModelWithIntId,
  IModificationRecord,
  IModifiedRecordParameters,
  INamedEntity,
  IOwnedEntity,
  IOwnedEntityParameters,
  IPermissionedEntity,
  IUniqueEntity,
  IUniqueEntityParameters,
  EntryRecordOrderBy,
  ModificationRecordOrderBy,
  NamedEntityOrderBy,
} from "./GenericTypes";

export const sharedContentConstants: EntityConstants<SharedContent, SharedContentFilters> = {
  resource: "shared_content",
  frontendIndexRoute: "shared_content",
  entitySingular: "shared content",
  entityPlural: "shared contents",
  icon: "share-2",
};

export interface SharedContentPublicModel {
  name?: string;
  allowContentDownload?: boolean;
  publicNotes?: string;
  requiresPassword: boolean;
  suppliedPasswordCorrect?: boolean;
}
export interface SharedContentPublicModelRequest {
  password?: string;
}

export interface SharedContent
  extends IModelWithIntId,
    INamedEntity,
    IOwnedEntity,
    IPermissionedEntity,
    IEntryRecord,
    IModificationRecord,
    IUniqueEntity {
  shareId: string;
  allowContentDownload: boolean;
  publicNotes: string;
  privateNotes: string;
  password: string;
  datasets: IEntityMinimalModel<number>[];
}

export const SharedContentFieldLabels: PropertyTranslator<SharedContent> & { link: string } = {
  ...INamedEntityLabels,
  ...IPermissionedEntityLabels,
  ...IEntryRecordLabels,
  ...IModificationRecordLabels,
  ...IUniqueEntityLabels,
  id: "Shared content ID",
  shareId: "Share ID",
  allowContentDownload: "Allow content download",
  publicNotes: "Public notes",
  privateNotes: "Private notes",
  password: "Password",
  datasets: "Datasets",
  owner: "Owned by",
  link: "Link",
} as const;

export interface SharedContentSuggestions extends IEntityMinimalModel<SharedContent["id"]> {}

export const SharedContentSortingOptionsConsts = [
  ...GenericEntityOrderBy,
  ...NamedEntityOrderBy,
  ...EntryRecordOrderBy,
  ...ModificationRecordOrderBy,
  ...OwnedOrderBy,
] as const;
export type SharedContentSortingOptions = (typeof SharedContentSortingOptionsConsts)[number];

export interface SharedContentFilters
  extends IGenericRequestParameters<SharedContent, SharedContentSortingOptions>,
    IOwnedEntityParameters,
    IUniqueEntityParameters,
    ICreatedRecordParameters,
    IModifiedRecordParameters {
  datasetIds?: number[] | null;
}
export const SharedContentFiltersTranslator: PropertyTranslator<SharedContentFilters> = {
  ...IGenericRequestParametersTranslator,
  ...IUniqueEntityParametersTranslator,
  ...IEntryRecordParametersTranslator,
  ...IModifiedRecordParametersTranslator,
  ...IOwnedEntityParametersTranslator,
  datasetIds: "Dataset IDs",
} as const;
